import React, { useContext, useState } from 'react';
import { Box, Typography, Chip, Grid, Button, Collapse, useMediaQuery } from '@mui/material';
import QuantityAdjuster from './subComponents/QuantityAdjuster';
import { OrdersContext } from '../../../lib/contexts/OrdersContext';
import SaveIcon from '@mui/icons-material/Save';
import useMealOptions from '../../../lib/hooks/useMealOptions';
import ClearIcon from '@mui/icons-material/Clear';

const MealInfoCard = ({ mealInfo, order, meal, handleDecrement, handleIncrement, onClose }) => {
  const {
    state: { mealOptionsData },
    actions: { updateMealQuantity },
  } = useContext(OrdersContext);
  const [showNutritionFacts, setShowNutritionFacts] = useState(false);
  const [quantity, setQuantity] = useState(meal?.quantity);
  // const { data: mealOptionsData } = useMealOptions(order.benefit_id);
  // console.log('here is the meal in MealInfoCard: ', meal);
  // console.log('here is the order in MealInfoCard: ', order);
  // console.log('here is the mealOptionsData in MealInfoCard: ', mealOptionsData);

  const isMobileView = useMediaQuery('(max-width: 600px)');

  const findMeal = (meal, mealOptionsData) => {
    if (mealOptionsData === undefined) {
      return null;
    }
    const mealID = meal.box_id;
    for (let i = 0; i < mealOptionsData?.boxes?.length; i++) {
      if (mealOptionsData?.boxes[i].box_id === mealID) {
        return mealOptionsData?.boxes[i];
      }
    }
    return {
      name: meal.box_name,
      description: meal.box_description,
      media: [meal.box_image],
      type: meal.box_type,
      ingredients: meal.ingredients,
    };
  };

  const actualMealInfo = findMeal(meal, mealOptionsData);

  // console.log('here is the meal in MealInfoCard: ', meal);
  // console.log('here is the mealOption in MealInfoCard: ', findMeal(meal, mealOptionsData));

  const handleAdjustQuantity = () => {
    if (meal) {
      updateMealQuantity(meal.order_id, meal.box_id, quantity);
    }
  };

  const toggleNutritionFacts = () => {
    setShowNutritionFacts(!showNutritionFacts);
  };

  const { mealName, description, tags, instructions, ingredients } = /*mealInfo ||*/ {
    mealName: actualMealInfo?.name,
    description: actualMealInfo?.description,
    tags: [],
    ingredients: actualMealInfo?.ingredients,
    instructions: '',
    // ingredients: 'Extra Firm Tofu, Rice Noodle (Rice, Water), Napa Cabbage, Green Bell Pepper, Water, Carrot, Crimini Mushrooms, Kikkoman LESS SODIUM GLUTEN-FREE TAMARI Soy Sauce (Water, Soybeans, Salt, Sugar, Alcohol, Vinegar, Lactic Acid), Olive Oil, Green Onion, Liquid Smoke, Rice Vinegar(Diluted with Water to 4.2% Acidity), Smooth Natural Peanut Butter, Sambal Oelek(Chili, Salt, Acetic Acid, Potassium Sorbate And Sodium Bisulfite As Preservative), Garlic, Maple Syrup, Garlic Powder, Cornstarch, Smoked Paprika, Peanuts, Cilantro, Ground Ginger, Ground Black Pepper, Salt',
    // instructions: 'Remove cover. Microwave for 1-3 minutes. Remove lid & stir contents. Microwave for 1-2 minutes more or until 165°F. Plate food, let stand & enjoy!'
  };

  // console.log('here is the meal in MealInfoCard: ', meal);
  // console.log('here are the ingredients in MealInfoCard: ', ingredients);

  return (
    <Box
      sx={{
        display: 'flex',
        width: isMobileView ? '100%' : '440px',
        padding: '24px 32px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        flexShrink: 0,
        borderLeft: '1px solid var(--color4, #EBE8F3)',
        background: 'var(--color1, #FDFDFD)',
        boxShadow:
          '0px 4px 5px 0px rgba(0, 0, 0, 0.02), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
      }}
    >
      <Box
        id="inner-box"
        sx={{
          display: 'flex',
          width: isMobileView ? '100%' : '375px',
          // height: '904px',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          background: '#FFF',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            height: '24px',
            flex: '1 0 0',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
        >
          <ClearIcon
            onClick={onClose}
            style={{
              width: '24px',
              height: '24px',
              fill: 'none',
              stroke: '#1C124D',
              strokeWidth: '2',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
          />
        </Box>
        <Box
          sx={{
            width: isMobileView ? '100%' : '258px',
            height: '258px',
            flexShrink: 0,
            borderRadius: '258px',
            background: `url(${actualMealInfo?.media[0]}) lightgray 50% / cover no-repeat`,
            boxShadow:
              '1px 2px 3px 0px rgba(0, 0, 0, 0.17), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
            marginTop: '40px',
          }}
        />
        <Box
          id="inner-most-box"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // padding: '25px 24px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            alignSelf: 'stretch',
            borderRadius: '22px',
            background: '#FFF',
          }}
        >
          <Grid
            id="meal-header-info"
            container
            direction="column"
            alignItems="center"
            spacing={1} // Adjust spacing as needed
          >
            <Grid item>
              <Typography
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  alignSelf: 'stretch',
                  overflow: 'hidden',
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  textOverflow: 'ellipsis',
                  fontFamily: 'Montserrat',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '125%', // 30px
                }}
              >
                {mealName}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  alignSelf: 'stretch',
                  color: 'var(--Gray-gray11, #6F6F6F)',
                  textAlign: 'center',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: 'normal',
                }}
              >
                {actualMealInfo?.type}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  alignSelf: 'center',
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: 'normal',
                  mb: 2,
                }}
              >
                {description}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  alignSelf: 'stretch',
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 800,
                  lineHeight: 'normal',
                  mb: 2,
                }}
              >
                Ingredients
              </Typography>
              <Box
                id="ingredients-list"
                sx={{
                  width: isMobileView ? '100%' : '327px',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '6px',
                  opacity: 1,
                  overflowY: 'auto',
                }}
              >
                {Array.isArray(ingredients) && ingredients.length > 0 ? (
                  <ul style={{ alignItems: 'center', margin: 0, padding: 0, textAlign: 'center' }}>
                    {ingredients.map((ingredient, index) => (
                      <li
                        key={index}
                        style={{ fontFamily: 'Montserrat', fontSize: '14px', color: '#1C124D' }}
                      >
                        {ingredient}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography
                    sx={{
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      width: isMobileView ? '100%' : '300px',
                      color: '#1C124D',
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'center',
                    }}
                  >
                    No ingredients available
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid item>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '24px',
                  alignSelf: 'stretch',
                  mb: 3,
                }}
              >
                {tags.map((tag, index) => (
                  <Chip
                    key={index}
                    label={tag}
                  />
                ))}
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            direction="column"
            alignItems="center"
            sx={{ alignSelf: 'stretch' }}
          >
            {handleDecrement && handleIncrement && (
              <Grid item>
                <Typography
                  sx={{
                    alignSelf: 'stretch',
                    color: 'var(--color12, #1C124D)',
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '125%', // 20px
                  }}
                >
                  Quantity to Add
                </Typography>
                {meal && handleDecrement && handleIncrement ? (
                  <QuantityAdjuster
                    quantity={quantity}
                    adjustQuantity={setQuantity}
                    handleDecrement={() => handleDecrement(meal.box_id)}
                    handleIncrement={() => handleIncrement(meal.box_id)}
                  />
                ) : (
                  <div>No meal data available</div>
                )}
              </Grid>
            )}
          </Grid>

          {/* New Grid for Prep Instructions */}
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: isMobileView ? '100%' : '327px',
              // height: '103px',
              gap: '12px',
              opacity: 1,
            }}
          >
            {instructions && (
              <Typography
                variant="h6"
                align="center"
                sx={{
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontWeight: 700,
                  lineHeight: '20px',
                  textAlign: 'center',
                  textUnderlinePosition: 'from-font',
                  textDecorationSkipInk: 'none',
                  color: 'var(--color12, #1C124D)',
                  padding: isMobileView ? '0px 0px' : '4px 8px',
                  borderRadius: '4px',
                }}
              >
                Prep Instructions
              </Typography>
            )}
            <Typography
              align="center"
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '19.5px',
                textAlign: 'center',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                color: 'var(--color12, #1C124D)',
              }}
            >
              {instructions}
            </Typography>
          </Grid>

          {/* Button for Nutrition Facts */}
          {/* <Button
            variant="outlined"
            onClick={toggleNutritionFacts}
            sx={{
              width: '327px',
              height: '44px', // Assuming a fixed height
              padding: '0 18px', // Adjust padding as needed
              gap: '18px', // Adjust gap as needed
              borderRadius: '4px', // Assuming a fixed border-radius
              border: '2px solid var(--color12, #1C124D)',
              mt: 2, // Optional: Add margin-top for spacing
            }}
          >
            Nutrition Facts
          </Button> */}

          {/* Collapsible Grid for Nutrition Facts */}
          <Collapse in={showNutritionFacts}>
            <Grid
              id="nutrition-facts-grid-container"
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{
                width: isMobileView ? '100%' : '327px',
                paddingTop: '16px',
                background: '#F5F5F5',
                borderRadius: '8px',
                mt: 2,
              }}
            >
              {/* Existing Row for Chips */}
              {/* <Grid
                id='nutrition-facts-chips'
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1} // Adjust spacing as needed
                sx={{ mt: 2 }}
              >
                <Grid item>
                  <Chip
                    label="Made Fresh"
                    // icon={<YourIconComponent />} // Replace with your icon component
                    sx={{
                      backgroundColor: '#E8F5E9', // Light green background
                      color: '#2E7D32', // Dark green text
                      borderRadius: '16px',
                      padding: '8px 16px',
                    }}
                  />
                </Grid>
                <Grid item>
                  <Chip
                    label="No Additives"
                    // icon={<YourIconComponent />} // Replace with your icon component
                    sx={{
                      backgroundColor: '#E8F5E9',
                      color: '#2E7D32',
                      borderRadius: '16px',
                      padding: '8px 16px',
                    }}
                  />
                </Grid>
                <Grid item>
                  <Chip
                    label="No Fillers"
                    // icon={<YourIconComponent />} // Replace with your icon component
                    sx={{
                      backgroundColor: '#E8F5E9',
                      color: '#2E7D32',
                      borderRadius: '16px',
                      padding: '8px 16px',
                    }}
                  />
                </Grid>
              </Grid> */}

              {/* New Grid with specified layout */}
              <Grid
                id="nutrition-facts-grid"
                container
                direction="column"
                alignItems="center"
                // justifyContent="center"
                sx={{
                  width: isMobileView ? '100%' : '327px',
                  height: '190px',
                  gap: '12px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontWeight: 700,
                    lineHeight: '20px',
                    textAlign: 'center',
                    textUnderlinePosition: 'from-font',
                    textDecorationSkipInk: 'none',
                    color: '#1C124D',
                  }}
                >
                  Ingredients
                </Typography>

                <Box
                  sx={{
                    width: isMobileView ? '100%' : '327px',
                    height: '158px',
                    gap: '6px',
                    opacity: 1,
                    overflowY: 'auto',
                  }}
                >
                  {Array.isArray(ingredients) && ingredients.length > 0 ? (
                    <ul style={{ paddingLeft: isMobileView ? '0px' : '20px', margin: 0 }}>
                      {ingredients.map((ingredient, index) => (
                        <li
                          key={index}
                          style={{ fontFamily: 'Montserrat', fontSize: '14px', color: '#1C124D' }}
                        >
                          {ingredient}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Typography
                      sx={{
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        width: isMobileView ? '100%' : '300px',
                        color: '#1C124D',
                        wordWrap: 'break-word',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      No ingredients available
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Collapse>
          {/* <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleAdjustQuantity}
                    sx={{
                        width: '100%',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        backgroundColor:'#4CAF50',
                        '&:hover': {
                            backgroundColor: '#45a049',
                        }
                    }}
                >
                    <Typography sx={{
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        }}>Save Changes</Typography>
                </Button> */}
        </Box>
      </Box>
    </Box>
  );
};

export default MealInfoCard;
